import { render, staticRenderFns } from "./OrderVCInfo.vue?vue&type=template&id=5b419978&scoped=true"
import script from "./OrderVCInfo.vue?vue&type=script&lang=js"
export * from "./OrderVCInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderVCInfo.vue?vue&type=style&index=0&id=5b419978&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b419978",
  null
  
)

export default component.exports